'use client';

import {
  SiteSearchSectionLabel,
  SiteSearchTopicLink,
} from '@/components/SiteSearch';
import { safeLocalStorage } from '@/lib/safeLocalStorage';
import { useSiteSearch } from '@/providers';

export function SiteSearchRecentSearches() {
  const { recentSearches, setRecentSearches } = useSiteSearch();

  if (!recentSearches?.length) {
    return null;
  }

  function handleRecentSearchClear() {
    if (
      window.confirm('Are you sure you want to clear your recent searches?')
    ) {
      safeLocalStorage.removeItem('recent-searches');
      if (setRecentSearches) {
        setRecentSearches([]);
      }
    }
  }

  return (
    <>
      <SiteSearchSectionLabel label="Recently Viewed Topics" />
      {recentSearches.map((topic, index) => (
        <SiteSearchTopicLink
          key={topic.slug}
          id={topic.slug}
          slug={topic.slug}
          label={topic.name}
          name={topic.name}
          listContext="recently-viewed"
          index={index}
        />
      ))}
      <div>
        <button
          className="text-body-350 flex items-center pl-6 mt-1"
          onClick={() => handleRecentSearchClear()}
        >
          Clear recently viewed
        </button>
      </div>
    </>
  );
}
